import React from 'react'

const Navbar = ({productRef, contactRef}) => {
    return (
        <div className="flex justify-between bg-black pt-4 pl-20 pr-20 items-center">
            <div className="w-64">
                <img src="/logo.png" />
            </div>
            <div className="text-white flex space-x-12 text-xl">
                <p className="cursor-pointer" onClick={() => { productRef.current.scrollIntoView({ behavior: 'smooth' })}}>Products</p>
                <p className="cursor-pointer" onClick={() => { contactRef.current.scrollIntoView({ behavior: 'smooth' })}}>Contact</p>
            </div>
        </div>
    )
}

export default Navbar
